(function () {
  const COOKIE_DAYS = 90;
  const ATTR_PREFIX = 'src_';
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  }
  function getCookie(name) {
    const n = name + '=';
    return document.cookie.split(';').map(c => c.trim()).reduce((acc, c) => {
      if (c.indexOf(n) === 0) acc = decodeURIComponent(c.substring(n.length));
      return acc;
    }, '');
  }
  function parseQuery(qs) {
    const p = new URLSearchParams(qs);
    const obj = {};
    p.forEach((v, k) => obj[k] = v);
    return obj;
  }
  function firstNonEmpty(...vals){ return vals.find(v => v && String(v).trim() !== ''); }
  const q = parseQuery(window.location.search);
  const utm = {
    utm_source: q.utm_source || '',
    utm_medium: q.utm_medium || '',
    utm_campaign: q.utm_campaign || '',
    utm_term: q.utm_term || '',
    utm_content: q.utm_content || '',
    gclid: q.gclid || '',
    fbclid: q.fbclid || ''
  };
  const hasFirstTouch = getCookie('_ft_set') === '1';

  const now = new Date().toISOString();
  const landingUrl = window.location.href.split('#')[0];
  const ref = document.referrer || '';

  const firstTouch = {
    ft_time: hasFirstTouch ? getCookie('_ft_time') : now,
    ft_landing: hasFirstTouch ? getCookie('_ft_landing') : landingUrl,
    ft_referrer: hasFirstTouch ? getCookie('_ft_referrer') : ref,
    ft_utm_source: hasFirstTouch ? getCookie('_ft_utm_source') : utm.utm_source,
    ft_utm_medium: hasFirstTouch ? getCookie('_ft_utm_medium') : utm.utm_medium,
    ft_utm_campaign: hasFirstTouch ? getCookie('_ft_utm_campaign') : utm.utm_campaign,
    ft_utm_term: hasFirstTouch ? getCookie('_ft_utm_term') : utm.utm_term,
    ft_utm_content: hasFirstTouch ? getCookie('_ft_utm_content') : utm.utm_content,
    ft_gclid: hasFirstTouch ? getCookie('_ft_gclid') : utm.gclid,
    ft_fbclid: hasFirstTouch ? getCookie('_ft_fbclid') : utm.fbclid
  };
  if (!hasFirstTouch) {
    setCookie('_ft_set', '1', COOKIE_DAYS);
    Object.entries(firstTouch).forEach(([k, v]) => setCookie(`_${k}`, v || '', COOKIE_DAYS));
  }
  const lastTouch = {
    lt_time: now,
    lt_landing: landingUrl,
    lt_referrer: ref,
    lt_utm_source: utm.utm_source,
    lt_utm_medium: utm.utm_medium,
    lt_utm_campaign: utm.utm_campaign,
    lt_utm_term: utm.utm_term,
    lt_utm_content: utm.utm_content,
    lt_gclid: utm.gclid,
    lt_fbclid: utm.fbclid
  };
  Object.entries(lastTouch).forEach(([k, v]) => setCookie(`_${k}`, v || '', COOKIE_DAYS));
  const cartAttributes = {};
  function put(attr, value) {
    if (value && String(value).trim() !== '') {
      cartAttributes[ATTR_PREFIX + attr] = String(value).slice(0, 500); // safety
    }
  }

  // first-touch
  put('ft_time', getCookie('_ft_time'));
  put('ft_landing', getCookie('_ft_landing'));
  put('ft_referrer', getCookie('_ft_referrer'));
  put('ft_utm_source', getCookie('_ft_utm_source'));
  put('ft_utm_medium', getCookie('_ft_utm_medium'));
  put('ft_utm_campaign', getCookie('_ft_utm_campaign'));
  put('ft_utm_term', getCookie('_ft_utm_term'));
  put('ft_utm_content', getCookie('_ft_utm_content'));
  put('ft_gclid', getCookie('_ft_gclid'));
  put('ft_fbclid', getCookie('_ft_fbclid'));

  // last-touch
  put('lt_time', lastTouch.lt_time);
  put('lt_landing', lastTouch.lt_landing);
  put('lt_referrer', lastTouch.lt_referrer);
  put('lt_utm_source', lastTouch.lt_utm_source);
  put('lt_utm_medium', lastTouch.lt_utm_medium);
  put('lt_utm_campaign', lastTouch.lt_utm_campaign);
  put('lt_utm_term', lastTouch.lt_utm_term);
  put('lt_utm_content', lastTouch.lt_utm_content);
  put('lt_gclid', lastTouch.lt_gclid);
  put('lt_fbclid', lastTouch.lt_fbclid);
  async function pushCartAttributes(attrs) {
    try {
      const cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }}).then(r=>r.json());
      const current = cart.attributes || {};
      const needUpdate = Object.keys(attrs).some(k => current[k] !== attrs[k]);
      if (!needUpdate) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { ...current, ...attrs } })
      });
    } catch (e) {
      console.warn('Cart attribution failed:', e);
    }
  }
  if (Object.keys(cartAttributes).length) {
    pushCartAttributes(cartAttributes);
  }
})();